/*istanbul ignore file */
import { Component, Inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { LoginService } from 'src/app/core/services/login.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AsappChatService } from '../../../../core/services/asapp-chat.service';

@Component({
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit {

  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private loginService: LoginService,
    private storageService: StorageService,
    private asappService: AsappChatService,
  ) { }

  async ngOnInit() {
    this.asappService.hide();
    this.asappService.unloadAndClearSession();
    const redirectToTechSupport = this.loginService.redirectToTechSupport;
    const failedLoginBycontract = this.loginService.failedLoginBycontract;
    this.oktaAuth.tokenManager.clear();
    this.storageService.clearLocal();
    sessionStorage.clear();
    // set the session variable again so it can be checked in AuthGuard.
    this.loginService.redirectToTechSupport = redirectToTechSupport;
    this.loginService.failedLoginBycontract = failedLoginBycontract;
    const phoneOnboardingWelcome = sessionStorage.getItem('phone-onboarding-welcome');
    if(phoneOnboardingWelcome && phoneOnboardingWelcome === 'skipped-test'){
      sessionStorage.removeItem('phone-onboarding-welcome');
    }
    await this.oktaAuth.signOut();
  }
}
